const ClientPixelHandler = require('./clientHandler');
const ServerPixelHandler = require('./serverHandler');

module.exports = {
  ClientPixelHandler,
  ServerPixelHandler
};
